'use strict';

var constants = require('../../../_virtual/constants.js_commonjs-exports.js');

Object.defineProperty(constants.__exports, "__esModule", {
  value: true
});
constants.__exports.MODIFIER_KEY_NAMES = constants.__exports.DEFAULT_VERTICAL_SPACING = constants.__exports.FANG_HEIGHT_PX = constants.__exports.FANG_WIDTH_PX = constants.__exports.WEEKDAYS = constants.__exports.BLOCKED_MODIFIER = constants.__exports.DAY_SIZE = constants.__exports.OPEN_UP = constants.__exports.OPEN_DOWN = constants.__exports.ANCHOR_RIGHT = constants.__exports.ANCHOR_LEFT = constants.__exports.INFO_POSITION_AFTER = constants.__exports.INFO_POSITION_BEFORE = constants.__exports.INFO_POSITION_BOTTOM = constants.__exports.INFO_POSITION_TOP = constants.__exports.ICON_AFTER_POSITION = constants.__exports.ICON_BEFORE_POSITION = constants.__exports.VERTICAL_SCROLLABLE = constants.__exports.VERTICAL_ORIENTATION = constants.__exports.HORIZONTAL_ORIENTATION = constants.__exports.END_DATE = constants.__exports.START_DATE = constants.__exports.ISO_MONTH_FORMAT = constants.__exports.ISO_FORMAT = constants.__exports.DISPLAY_FORMAT = void 0;
var DISPLAY_FORMAT = 'L';
constants.__exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
var ISO_FORMAT = 'YYYY-MM-DD';
constants.__exports.ISO_FORMAT = ISO_FORMAT;
var ISO_MONTH_FORMAT = 'YYYY-MM'; // TODO delete this line of dead code on next breaking change

constants.__exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
var START_DATE = 'startDate';
constants.__exports.START_DATE = START_DATE;
var END_DATE = 'endDate';
constants.__exports.END_DATE = END_DATE;
var HORIZONTAL_ORIENTATION = 'horizontal';
constants.__exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
var VERTICAL_ORIENTATION = 'vertical';
constants.__exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
var VERTICAL_SCROLLABLE = 'verticalScrollable';
constants.__exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
var ICON_BEFORE_POSITION = 'before';
constants.__exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
var ICON_AFTER_POSITION = 'after';
constants.__exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
var INFO_POSITION_TOP = 'top';
constants.__exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
var INFO_POSITION_BOTTOM = 'bottom';
constants.__exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
var INFO_POSITION_BEFORE = 'before';
constants.__exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
var INFO_POSITION_AFTER = 'after';
constants.__exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
var ANCHOR_LEFT = 'left';
constants.__exports.ANCHOR_LEFT = ANCHOR_LEFT;
var ANCHOR_RIGHT = 'right';
constants.__exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
var OPEN_DOWN = 'down';
constants.__exports.OPEN_DOWN = OPEN_DOWN;
var OPEN_UP = 'up';
constants.__exports.OPEN_UP = OPEN_UP;
var DAY_SIZE = 39;
constants.__exports.DAY_SIZE = DAY_SIZE;
var BLOCKED_MODIFIER = 'blocked';
constants.__exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
constants.__exports.WEEKDAYS = WEEKDAYS;
var FANG_WIDTH_PX = 20;
constants.__exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
var FANG_HEIGHT_PX = 10;
constants.__exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
var DEFAULT_VERTICAL_SPACING = 22;
constants.__exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
constants.__exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;

module.exports = constants.__exports;
